

































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { DataOptions } from 'vuetify';
import { getModule } from 'vuex-module-decorators';
import { toCurrency } from '@/utils';
import TableUtils from '@/utils/tableUtils';
import DynamicColumnMenu from '@/components/tables/DynamicColumnMenu.vue';
import ButtonFilterMenuOptions from '@/components/buttons/ButtonFilterMenuOptions.vue';
import ClientSaleOrders from '@/domain/models/ClientSaleOrders';
import GroupFilterParametersEnum from '@/domain/enums/GroupFilterParametersEnum';
import FilterParameterCustomerSellsInCustomerScreen from '@/domain/models/filter-parameters/FilterParameterCustomerSellsInCustomerScreen';
import GetClientSalesOrderFilterParams from '@/views/clients/types/GetClientSalesOrderFilterParams';
import FilterParameterHelper from '@/helpers/FilterParameterHelper';
import DateInputHelper from '@/helpers/DateInputHelper';
import FilterParametersRepository from '@/repositories/FilterParametersRepository';
import ClientRepository from '@/repositories/ClientRepository';
import ClientModule from '@/stores/modules/ClientModule';
import AuthenticationModule from '@/stores/modules/AuthenticationModule';
import OnRequestTableOptions from '@/types/OnRequestTableOptions';
import VMenuOptions from '@/types/VMenuOptions';
import LooseObjectType from '@/types/LooseObjectType';
import RangeDate from '@/types/RangeDate';
import IVDataTableHeader from '@/types/IVDataTableHeader';

@Component({
  components: {
    DynamicColumnMenu,
    ButtonFilterMenuOptions,
  },
})
export default class ClientSells extends Vue {
  @Watch('dataTableOptions')
  onSortDirectionDataTableChange() {
    this.getClientSells({ resetToFirst: false });
  }

  public loading: boolean = false;

  public totalItems: number = 0;

  public search: string = '';
  public consideredColumnToSearch: string = '';

  private readonly clientModule: ClientModule = getModule(ClientModule);
  private readonly authenticationModule: AuthenticationModule = getModule(AuthenticationModule);
  private readonly clientRepository: ClientRepository = new ClientRepository();
  private readonly filterParametersRepository:
    FilterParametersRepository = new FilterParametersRepository();

  public defaultButtonFilterMenuOption: VMenuOptions | null = null;
  public formattedRangeDate: LooseObjectType = {};
  public headerKeysObject: LooseObjectType<string> = {
    invoiceSerie: 'data_table_sale_orders_customer_screen_show_column_invoice_serie',
    issueDate: 'data_table_sale_orders_customer_screen_show_column_issue_date',
    order: 'data_table_sale_orders_customer_screen_show_column_order',
    orderInclusionDate: 'data_table_sale_orders_customer_screen_show_column_order_inclusion_date',
    channel: 'data_table_sale_orders_customer_screen_show_column_channel',
    value: 'data_table_sale_orders_customer_screen_show_column_value',
    status: 'data_table_sale_orders_customer_screen_show_column_status',
  }
  public formattedNfEmissionRangeDate: Partial<RangeDate> = {};
  public formattedInclusionRangeDate: Partial<RangeDate> = {};
  public dataTableOptions: DataOptions = {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
  }
  public footerOptions: Object = {
    'items-per-page-options': [5, 10, 15, 50],
  }

  public nfEmissionRangeDate: Array<string> = []
  public saleInclusionDateRange: Array<string> = []
  public saleOrders: Array<ClientSaleOrders> = [];
  public availableHeaders: IVDataTableHeader[] = [
    {
      text: 'Nota Fiscal / Série',
      value: 'invoiceSerie',
      show: true,
    },
    {
      text: 'Emissão NF',
      value: 'invoiceEmission',
      show: true,
    },
    {
      text: 'Pedido',
      value: 'order',
      show: true,
    },
    {
      text: 'Inclusão Pedido',
      value: 'orderInclusionDate',
      show: true,
    },
    {
      text: 'Canal de Vendas',
      value: 'channel',
      show: true,
    },
    {
      text: 'Valor Total',
      value: 'value',
      show: true,
    },
    {
      text: 'Status',
      value: 'status',
      show: true,
    },
  ];

  public get filtersFromInput(): VMenuOptions[] {
    let availableHeaders = [...this.availableHeaders];

    availableHeaders = availableHeaders.slice(1);
    availableHeaders.unshift(
      { text: 'Nota Fiscal', value: 'invoice' },
      { text: 'Série', value: 'serie' },
    );

    const totalIndex = availableHeaders.findIndex(({ value }) => value === 'value');
    availableHeaders.splice(totalIndex, 1);

    return availableHeaders.map(({ text, value }) => ({ text, value }));
  }

  public get clientId(): string {
    return this.$route.params.id;
  }

  public get headers(): IVDataTableHeader[] {
    return this.availableHeaders
      .filter((h) => h.show)
      .concat({
        text: '',
        value: 'dynamic',
        class: 'dynamic-columns',
        cellClass: 'dynamic-columns',
        sortable: false,
        filterable: false,
      })
      .concat({
        text: '',
        value: 'actions',
        class: 'actions-columns',
        cellClass: 'actions-columns',
        sortable: false,
        filterable: false,
      });
  }

  public async created(): Promise<void> {
    await this.getGroupFilterParameters();
    await this.getClientSells({ resetToFirst: false });
  }

  public async getGroupFilterParameters(): Promise<void> {
    this.loading = true;

    try {
      const filterParameters = await this.filterParametersRepository
        .getFilterByGroup(GroupFilterParametersEnum.SALES_ORDER_CLIENT_LIST);
      const formattedFilters = FilterParameterCustomerSellsInCustomerScreen.make(filterParameters);

      this.applyFiltersOnActualPage(formattedFilters);
    } catch (error) {
      this.$notification.error('Houve um problema ao requisitar os filtros dessa tela!');
    } finally {
      this.loading = false;
    }
  }

  public applyFiltersOnActualPage(filters: FilterParameterCustomerSellsInCustomerScreen): void {
    this.dataTableOptions.sortBy = filters.tableSort;
    this.dataTableOptions.sortDesc = filters.tableDirection;
    this.dataTableOptions.itemsPerPage = filters.rowsPerPage;
    this.dataTableOptions.page = filters.actualPage;

    this.nfEmissionRangeDate = filters.nfEmissionRangeDate;
    this.saleInclusionDateRange = filters.saleInclusionDateRange;

    const formattedNfEmissionRangeDate = DateInputHelper
      .formatRangeDate(filters.nfEmissionRangeDate);

    if (formattedNfEmissionRangeDate) {
      this.formattedNfEmissionRangeDate = formattedNfEmissionRangeDate;
    }

    const formattedInclusionRangeDate = DateInputHelper
      .formatRangeDate(filters.saleInclusionDateRange);

    if (formattedInclusionRangeDate) {
      this.formattedInclusionRangeDate = formattedInclusionRangeDate;
    }

    this.defaultButtonFilterMenuOption = FilterParameterHelper
      .getFormattedColumnObjectOfOptionsButton(this.filtersFromInput, filters.columnToSearch);

    this.consideredColumnToSearch = filters.columnToSearch;

    this.availableHeaders = FilterParameterHelper
      .defineColumnsToShowOnSpecificHeader(this.availableHeaders, filters.columnsToShow);
  }

  public async getClientSells(onRequestTableOptions: OnRequestTableOptions = {}): Promise<void> {
    if (this.loading) {
      return;
    }

    if (
      this.clientModule.client.companyId === null
      || this.clientModule.client.companyId === undefined
    ) {
      this.$notification.warn('O id da empresa desse cliente não foi definido!');

      return;
    }

    if (onRequestTableOptions.resetToFirst) {
      this.dataTableOptions.page = 1;
    }

    this.loading = true;

    const { sortDesc } = this.dataTableOptions;
    const sortBy = this.dataTableOptions.sortBy[0] === 'invoiceSerie' ? ['invoice'] : this.dataTableOptions.sortBy;

    const tableConfigParams: GetClientSalesOrderFilterParams = {
      companyId: this.clientModule.client.companyId,
      search: this.search,
      columnToSearch: this.consideredColumnToSearch,
      initialNfEmissionDate: this.formattedNfEmissionRangeDate.initial_date,
      finalNfEmissionDate: this.formattedNfEmissionRangeDate.final_date,
      initialSaleInclusionDate: this.formattedInclusionRangeDate.initial_date,
      finalSaleInclusionDate: this.formattedInclusionRangeDate.final_date,
      sort: TableUtils.tableOrdenationFormatterToLaravel(sortDesc[0], sortBy[0]),
      actualPage: this.dataTableOptions.page,
      rowsPerPage: this.dataTableOptions.itemsPerPage,
    };

    try {
      this.filterParametersRepository
        .setFilter(GroupFilterParametersEnum.SALES_ORDER_CLIENT_LIST, [
          { key: 'sort_table_sale_orders_customer_screen', value: tableConfigParams.sort },
          { key: 'rows_per_page_sale_orders_customer_screen', value: this.dataTableOptions.itemsPerPage },
          { key: 'actual_page_sale_orders_customer_screen', value: this.dataTableOptions.page },
          { key: 'nf_emission_range_date_search_sale_orders_customer_screen', value: JSON.stringify(this.nfEmissionRangeDate) },
          { key: 'inclusion_range_date_search_sale_orders_customer_screen', value: JSON.stringify(this.saleInclusionDateRange) },
          { key: 'column_to_search_sale_orders_customer_screen', value: this.consideredColumnToSearch },
        ]);

      const { data, total } = await this.clientRepository.getClientSells(
          this.clientId,
          this.authenticationModule.user.company_group_id,
          tableConfigParams,
        );

      this.saleOrders = data;
      this.totalItems = total;
    } catch (error) {
      this.$notification.error('Houve um problema ao requisitar as vendas!');
    } finally {
      this.loading = false;
    }
  }

  public getChipColor(status: string): string {
    switch (status) {
      case 'A Faturar':
        return '#9994D5';
      case 'Bloq Fin':
        return '#E9637B';
      case 'Faturado':
        return '#0EB799';
      default:
        return 'primary';
    }
  }

  public getMoneyFormat(num: number): string {
    return (num > 0 ? toCurrency(num) : '-');
  }

  public handleColumnChange(newColumnPresets: IVDataTableHeader[]): void {
    this.availableHeaders = newColumnPresets;
  }

  public handleSearch(search: string): void {
    this.search = search;

    this.getClientSells({
      resetToFirst: true,
    });
  }

  public async handleSelectDateRange(dateField: 'nfEmissionRangeDate' | 'saleInclusionDateRange'): Promise<void> {
    await this.$nextTick();

    const correlationBetweenDateAndFormattedFieldDate: {
      nfEmissionRangeDate: 'formattedNfEmissionRangeDate',
      saleInclusionDateRange: 'formattedInclusionRangeDate',
    } = {
      nfEmissionRangeDate: 'formattedNfEmissionRangeDate',
      saleInclusionDateRange: 'formattedInclusionRangeDate',
    };
    const formattedDate = DateInputHelper.formatRangeDate(this[dateField]);

    if (formattedDate === null) {
      this.$notification.warn('O range de data está inválido!');

      return;
    }

    this[correlationBetweenDateAndFormattedFieldDate[dateField]] = formattedDate;
    this.getClientSells({
      resetToFirst: true,
    });
  }

  public handleSelectedOptionChange(selectedOption: VMenuOptions | null): void {
    let valueToConsideredColumn = '';

    if (selectedOption !== null) {
      valueToConsideredColumn = selectedOption.value;
    }

    this.consideredColumnToSearch = valueToConsideredColumn;

    if (!this.search) {
      return;
    }

    this.getClientSells({
      resetToFirst: true,
    });
  }
}
